import { memo, useEffect, useState, useRef } from "react"

import ProductService from "@/services/product"
import { Stack, Text, Image, AspectRatio, Center, Button, Container, Box, Table, IconButton, Input, Card, VStack, HStack, Flex } from "@chakra-ui/react"
import { useCart } from "contexts/cart"
import { formatCurrency } from "@/utilities/number"


import { StepperInput } from "@/components/ui/stepper-input"
import { useApp } from "contexts/app"
import { useAuth } from "contexts/auth"
import { useForm, Controller } from "react-hook-form"
import { Field } from "@/components/ui/field"
import { useNavigate } from "react-router"

import Bank from "./Bank"
import _ from "lodash"
import ProfileService from "@/services/profile"
import OtpInput from "components/otp-input"

const service = new ProfileService();


const Cart = () => {
    const { setProcessing, setPageTitle, showToast } = useApp();
    const formRef = useRef();
    const [showOtp, setShowOtp] = useState(false)
    const [idOtp, setIdOtp] = useState();
    useEffect(() => {
        setPageTitle("Thông tin ngân hàng")
    }, [setPageTitle])

    const navigate = useNavigate();

    const { user, logout } = useAuth();
    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue, control
    } = useForm()
    useEffect(() => {
        var bank = user.bank ?? {};
        setValue("bank_bin", bank.bank_bin)

        setValue("account_number", bank.account_number)
        setValue("account_name", bank.account_name)

    }, [user])


    const onSubmit = handleSubmit(async (data) => {
        console.log("data", data)
        setProcessing(true);
        var data = await service.requestBankChange(data);
        setIdOtp(data.otp.id);
        setShowOtp(true)
        setProcessing(false);
    })


    const onOtpOk = async (otp) => {

        setProcessing(true);
        try {
            await service.saveBankWithOTP({ id: idOtp, otp: otp })
            showToast("Đã cập nhật")
        } catch (error) {
            showToast({ description: "Mã xác thực sai hoặc hết hạn", type: "error" });
        }
        setProcessing(false);


    }










    return (
        <div style={{ paddingBottom: 75 }}>

            <div>
                <form ref={formRef} onSubmit={onSubmit}  >
                    <Stack gap="4" align="flex-start" maxW="sm">
                        <Text >Tài khoản nhận hoa hồng</Text>
                        <Field
                            label="Ngân hàng"
                            invalid={!!errors.bank_bin}
                            errorText={errors.bank_bin?.message}
                        >



                            <Controller
                                name="bank_bin"
                                control={control}
                                rules={{ required: true }}
                                render={({ field }) => <Bank {...field} />}
                            />


                            {/* <Bank
                                {...register("bank_bin", { required: "Bạn phải chọn ngân hàng" })}
                            /> */}


                        </Field>
                        <Field
                            label="Số tài khoản"
                            invalid={!!errors.account_number}
                            errorText={errors.account_number?.message}
                        >
                            <Input
                                {...register("account_number", { required: "Bạn phải nhập số tài khoản" })}
                            />
                        </Field>
                        <Field
                            label="Họ tên tài khoản"
                            invalid={!!errors.account_name}
                            errorText={errors.account_name?.message}
                        >
                            <Input
                                {...register("account_name", { required: "Bạn phải nhập họ tên tài khoản" })}
                            />
                        </Field>
                        <Flex justifyContent={"flex-end"} style={{width:"100%"}}>
                            <Button onClick={e => handleSubmit(onSubmit)()}>Cập nhật</Button>
                        </Flex>

                    </Stack>
                </form>


            </div>



            <OtpInput open={showOtp} onOpenChange={e => setShowOtp(e)} onOk={onOtpOk}> </OtpInput>
        </div >
    )
}



export default memo(Cart)